"use client";
import { PageTitle } from "@/components/Lib/PageTitle";
import React from "react";
import { getCookie } from "cookies-next";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Contract from "@/components/Misc/Contract";
import { ContactForm } from "@/components/Misc/ContactForm";
import FileUploader from "@/components/Lib/FileUploader";

export default function Page() {
  let userData, docsSent
    try {
        const cookie = getCookie("userData") as string;
        userData = JSON.parse(decodeURIComponent(atob(cookie)));
        docsSent = getCookie("docsSent");
    } catch {
        return null;
    }
    return (
        <>
            <PageTitle title="Multumim!" />
            <div className="px-4 py-0 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-0 lg:px-0 lg:pt-10">
                <p className="mb-2 text-xs font-semibold tracking-wide text-gray-600 uppercase sm:text-center">
                    {new Date()
                        .toLocaleDateString("ro-RO")
                        .split("/")
                        .reverse()
                        .join(" ")}
                </p>
                <div className="max-w-xl mb-0 md:mx-auto sm:text-center lg:max-w-2xl">
                    <div className="mb-10">
                        <h3 className="inline-block max-w-lg font-sans text-3xl font-extrabold leading-none tracking-tight text-black transition-colors duration-200 hover:text-deep-purple-accent-700 sm:text-4xl">
                            Felicitari, {userData.fullName}!
                        </h3>
                    </div>
                    <div className="grid gap-6 md:grid-cols-2 md:col-span-1 lg:col-span-3">
                        <PDFDownloadLink
                            document={<Contract formData={userData} />}
                            fileName="contract.pdf"
                            className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-indigo-50"
                        >
                            <div className="flex items-center mb-1">
                                <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-white rounded bg-deep-purple-accent-400">
                                    1
                                </span>
                                <p className="text-lg font-semibold sm:text-base text-left">
                                    Contractul de Scolarizare
                                </p>
                            </div>
                            <p className="text-sm text-gray-900 text-justify">
                                Click aici pentru a descrca contractul de
                                scolarizare auto.
                            </p>
                        </PDFDownloadLink>
                        <a
                            href="https://hub.mai.gov.ro/serviciu/index"
                            target="_blank"
                            className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-teal-50"
                        >
                            <div className="flex items-center mb-1">
                                <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-teal-900 rounded bg-teal-accent-400">
                                    2
                                </span>
                                <p className="text-lg font-semibold sm:text-base text-left">
                                    Cazierul Judiciar
                                </p>
                            </div>
                            <p className="text-sm text-gray-900 text-justify">
                                Click aici pentru a obtine cazierul judiciar
                                online.
                            </p>
                        </a>
                    </div>
                    {!docsSent && <FileUploader />}
                    {docsSent && (
                        <p className="text-sm italic">
                            Multumim! Documentele tale au ajuns la noi!
                        </p>
                    )}
                    <div className="text-justify space-y-5 mt-10">
                        <p>
                            Acum că ai achitat avansul, ești oficial înscris la
                            scoala de soferi! Apreciem încrederea acordată și
                            suntem încântați să fim parte din experiența ta de
                            obținere a permisului de șofer!
                        </p>
                        <p>
                            Partenerul cu care vei face orele se numeste{" "}
                            <a href="https://scoalatop.ro" className="href">
                                Scoala de Soferi TOP
                            </a>
                            . În următoarele 24 de ore, unul dintre colegii
                            noștri va lua legătura cu tine pentru a stabili
                            detaliile ulterioare. Ei vor fi responsabili de
                            coordonarea programului tău de școlarizare și de
                            răspunsul la întrebările și cererile tale. Vom face
                            tot posibilul să asigurăm că procesul tău de
                            învățare va fi cât mai fluid și eficient posibil.
                        </p>
                        <p>
                            În cazul în care nu primești un apel în termenul
                            menționat sau ai orice altă întrebare, te rugăm să
                            ne contactezi prin intermediul metodelor de
                            comunicare disponibile pe site-ul nostru. Suntem
                            aici pentru a te ajuta și a te sprijini pe parcursul
                            întregului proces de școlarizare.
                        </p>
                        <p>
                            Bine ai venit în comunitatea Scoala.Buzz și abia
                            așteptăm să te ajutăm să obții permisul de
                            conducere. Începem împreună această călătorie către
                            drumurile deschise și libertatea de a conduce.
                            Succes!
                        </p>
                    </div>
                    <div className="my-10">
                        <h3 className="inline-block max-w-lg font-sans text-3xl font-extrabold leading-none tracking-tight text-black transition-colors duration-200 hover:text-deep-purple-accent-700 sm:text-4xl">
                            Ai intrebari? Scrie-ne!
                        </h3>
                    </div>
                    <ContactForm />
                </div>
            </div>
        </>
    );
}
